<template>
  <div class="bblayout">
    <component
      v-if="hasAliApp"
      :is="'script'"
      type="text/javascript"
      src="https://appx/web-view.min.js"
    ></component>
    <slot></slot>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import Ditto from "@zeekr-f2e/zeekr-ditto";
import { useRoute } from "vue-router";
const route = useRoute();
const ua = window.navigator.userAgent.toLowerCase();
const isIos =
  /(ios|ipad|iphone)/.test(ua) ||
  (ua.indexOf("macintosh") > -1 && "ontouchend" in document);
const hasAliApp = ref(ua.indexOf("aliapp") > -1);
const hasWx = ref(ua.match(/MicroMessenger/i) == "micromessenger");
// 前往订阅页
const toSub = () => {
  if (hasAliApp.value) {
    // 支付宝内
    my.navigateBack();
    my.redirectTo({ url: "/pages/index/index" });
  } else if (hasWx.value) {
    // 微信内
    if (!isIos) {
      wx.miniProgram.navigateBack();
    }
    wx.miniProgram.switchTab({ url: "/pages/subscribe/subscribe" });
  } else {
    // 默认认为是app
    Ditto.openNative({
      protocol:
        "app://route/openNative?path=/subscription/subs&data=" +
        JSON.stringify({
          path: "/subscription/subs",
          type: "2",
        }),
    });
  }
};
// 前往登录
const toLogin = () => {
  if (hasAliApp.value) {
    // 支付宝内
    my.navigateTo({
      url: `/pages/login/index`,
    });
  } else if (hasWx.value) {
    // 微信内
    wx.miniProgram.navigateTo({
      url: "/mine/login/signIn"
    });
  } else {
    // 默认认为是app
    const _data = {
      path: "subscription_biz_mine.ZUSubscriptionLoginViewController",
    };
    Ditto.openNative({
      protocol:
        "app://route/openNative?path=/subscription/login&data=" + JSON.stringify(_data),
    });
  }
};
onMounted(() => {
  // todo 判断登录
  console.log("🚀 ~ onMounted ~ location.href:", location.href);
});
defineExpose({
  toSub,
  toLogin,
});
</script>
<style lang="scss" scoped></style>
